// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__kj5nt","inner":"Footer_inner__1uZxH"};